import React from 'react';

import Section from './Section';

const RenaperSelfieTips = ({ onFinish }) => {
  return (<div className='renaper-background'>
    <Section className="intro_form">
      <div className="row">
        <div className="pd-content-left col-md-5 col-lg-5 text-center" >
          <div className="header-img" >
            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
          </div>
          <div className="header-message">
            <h3><b>Validación de identidad.</b></h3>
          </div>
        </div>
        <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
          <div className="pvc-form">
            <div className="row">
              <span>
                <div className="col-sm-10 col-md-10 col-lg-10 col-sm-offset-1 col-md-offset-1 col-lg-offset-1 text-center">
                  <div>
                    <p style={{
                      fontFamily: "Rubik,sans-serif!important",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "150%",
                    }}>
                      <b>Sirve para confirmar que sos la persona que indica tu DNI.</b>
                    </p>
                  </div>
                  <div>
                    <p style={{
                      fontFamily: "Rubik,sans-serif!important",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "150%",
                    }}>
                      <b>Necesitamos que hagas algunos gestos.</b>
                    </p>
                  </div>

                </div>
              </span>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                <button
                  type="submit"
                  className="btn btn-warning btn-lg pd-button pd-form"
                  onClick={(event) => {
                    event.preventDefault();
                    onFinish();
                  }}>
                  Entendido
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section >
  </div>)
}

module.exports = RenaperSelfieTips;



/** WEBPACK FOOTER **
 ** ./src/components/RenaperSelfieTips.js
 **/